import { useEffect } from 'react'

import type { PayloadSearch } from '@/modules/shared/types/payload-search.type'

import { useAutoCalculateOrderFormJson } from '@/modules/product/hooks/use-auto-calculate-order-form-json.hook'
import { useLayoutsStore } from '../../stores/layouts.store'
import { useProducts } from '../../hooks/use-products.hook'

export type TCreatePayloadToSearchProduct = {
  payload?: PayloadSearch
  filterAll?: string
  inputValueAll?: string
}

export const useCatalogComponent = () => {
  const {
    layoutType,
    actions: { setLayoutType },
  } = useLayoutsStore()

  const {
    isLoadingProducts,
    lastProductOfPaginationCallback,
    handleSubmitSearchProduct,
    products,
  } = useProducts()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

	const { isCalculatingOrder } = useAutoCalculateOrderFormJson()

 const handleLayout = () => {
    if (layoutType === 'grid') {
      setLayoutType('list')
    } else {
      setLayoutType('grid')
    }
  }


  return {
		layoutType,
    isLoadingProducts,
    products,
    lastProductOfPaginationCallback,
    handleSubmitSearchProduct,
		isCalculatingOrder,
		handleLayout
  }
}
